/**
 * Update Notification Component
 * Shows when a new version of the app is available
 */

import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './UpdateNotification.css';
import { trackEvent } from '../../utils/analytics';

const UpdateNotification = () => {
  const { t } = useTranslation('mobile', { useSuspense: false });
  const [showUpdate, setShowUpdate] = useState(false);
  const [registration, setRegistration] = useState(null);

  useEffect(() => {
    const handleUpdateAvailable = (event) => {
      console.log('[UpdateNotification] Update available');
      setRegistration(event.detail.registration);
      setShowUpdate(true);
      trackEvent('pwa_update_available');
    };

    window.addEventListener('swUpdateAvailable', handleUpdateAvailable);

    return () => {
      window.removeEventListener('swUpdateAvailable', handleUpdateAvailable);
    };
  }, []);

  const handleUpdate = () => {
    if (!registration || !registration.waiting) {
      return;
    }

    console.log('[UpdateNotification] Applying update');
    trackEvent('pwa_update_accept');

    // Tell service worker to skip waiting
    registration.waiting.postMessage({ type: 'SKIP_WAITING' });

    // Reload will happen automatically when controller changes
    setShowUpdate(false);
  };

  const handleDismiss = () => {
    console.log('[UpdateNotification] Update dismissed');
    setShowUpdate(false);
    trackEvent('pwa_update_dismiss');

    // Auto-show again after 24 hours
    setTimeout(() => {
      if (registration && registration.waiting) {
        setShowUpdate(true);
      }
    }, 24 * 60 * 60 * 1000);
  };

  if (!showUpdate) {
    return null;
  }

  return (
    <div className="update-notification">
      <div className="update-notification-content">
        <div className="update-notification-icon">✨</div>

        <div className="update-notification-text">
          <span className="update-notification-title">{t('pwa.update.title', { defaultValue: 'New version available!' })}</span>
          <span className="update-notification-subtitle">{t('pwa.update.subtitle', { defaultValue: 'Update for the latest features' })}</span>
        </div>

        <div className="update-notification-actions">
          <button
            className="update-notification-btn update-notification-btn-primary"
            onClick={handleUpdate}
          >
            {t('common.actions.update', { defaultValue: 'Update' })}
          </button>
          <button
            className="update-notification-btn update-notification-btn-secondary"
            onClick={handleDismiss}
          >
            {t('common.actions.later', { defaultValue: 'Later' })}
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdateNotification;
